import {connect} from '../../app/connect';
import TemplatesFilter from './TemplatesFilter';
import {
  getTemplateCategoriesEntitiesMap,
  getTemplatesQueryParams,
  getTemplateCategories,
  getActiveIssueSubTypesGroupedDropdownOptions,
  getIssueTypesAdminEntitiesMap,
  getIsLocationsTreeLoading,
  getIsLocationsLoadingError,
  getLocationsTreeNodes,
  getAllOxygenMappings,
  getGroupedProjectActiveEntities,
  getActiveUsers,
  getActiveIssueRootCausesGroupedDropdownOptions,
  getIssueRootCausesDefinitionsEntitiesMap,
  getUncategorizedTemplateCategory
} from '../../app/selectors';
import {setQueryParamsAction} from '../../app/actions';
import LocationsThunk from '../../app/thunk/locationsThunk';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';

const mapStateToProps = state => {
  const uncategorizedCategory = getUncategorizedTemplateCategory(state);
  const templateCategories = [...getTemplateCategories(state)];
  if (uncategorizedCategory) {
    templateCategories.push(uncategorizedCategory);
  }

  return {
    queryParams: getTemplatesQueryParams(state),
    templateCategoriesEntitiesMap: getTemplateCategoriesEntitiesMap(state),
    templateCategories,
    subTypesGroupedDropdownOptions: getActiveIssueSubTypesGroupedDropdownOptions(state),
    fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMap(state),
    isLocationsTreeLoading: getIsLocationsTreeLoading(state),
    isLocationsLoadingError: getIsLocationsLoadingError(state),
    locationsTreeNodes: getLocationsTreeNodes(state),
    oxygen: getAllOxygenMappings(state),
    groupedProjectEntities: getGroupedProjectActiveEntities(state),
    users: getActiveUsers(state),
    issueRootCausesGroupedDropdownOptions: getActiveIssueRootCausesGroupedDropdownOptions(state),
    rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state),
    isDateSelectorMigrationEnabled: featureFlags.get(FEATURE_FLAGS.DATE_SELECTOR)
  };
};

const mapDispatchToProps = {
  setQueryParamsAction,
  getDefaultLocationTree: LocationsThunk.getDefaultTree
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplatesFilter);
